import { useContext } from "react"
import { SessionServiceContext } from "../service/SessionService";

export const useSessionService = () => {
    const context = useContext(SessionServiceContext);
    return context;
}